/**
 * @description This function is used to get the term changes based on the isPPGenarate and isPartPaymentCostAdded flags.
 * @param isPPGenarate - flag to indicate if part payment is generated
 * @param termCharge - term charge amount
 * @param isPartPaymentCostAdded - part payment cost is already added
 * @returns
 */
export const getTermChanges = (
  isPPGenarate: boolean,
  termCharge: number,
  isPartPaymentCostAdded: boolean | undefined
) => {
  try {
    return isPPGenarate ? termCharge : (isPartPaymentCostAdded ? 0 : termCharge);
  } catch (error) {
    return termCharge;
  }
};
